// extracted by mini-css-extract-plugin
export var errorsContainer = "_v0-1";
export var link = "_v0-0";